export class PauseMenu {
  readonly el: HTMLElement;
  onResume?: () => void;
  onCustomize?: () => void;
  onQuitToTitle?: () => void;

  constructor(root: HTMLElement) {
    this.el = document.createElement('div');
    this.el.className = 'overlay hidden';
    this.el.innerHTML = `
      <div class="panel" style="max-width:420px; text-align:center">
        <h1 style="font-size:28px">Paused</h1>
        <p class="subtitle">Take a breath ✿</p>
        <div class="menu-buttons">
          <button class="btn" data-action="resume">Resume</button>
          <button class="btn secondary" data-action="customize">Customize Character</button>
          <button class="btn ghost" data-action="title">Return to Title</button>
        </div>
      </div>
    `;
    root.appendChild(this.el);
    this.el.querySelector('[data-action="resume"]')!.addEventListener('click', () => this.onResume?.());
    this.el.querySelector('[data-action="customize"]')!.addEventListener('click', () => this.onCustomize?.());
    this.el.querySelector('[data-action="title"]')!.addEventListener('click', () => this.onQuitToTitle?.());
  }

  show(): void { this.el.classList.remove('hidden'); }
  hide(): void { this.el.classList.add('hidden'); }
}
